import { useEffect } from "react";
import { Input, Form, Select, Divider } from "antd";
import { getLangList } from '@/lib/i18n';
import { getOptionArray, getDataArray, selectFilterOption, modalFromLayout } from "@/lib/antdElementFunction";
import { hasPermission } from "@/lib/permissionUtil";
import { ReButton } from "@/components/refineElement";
import { SaleSubjectType, CategoryType } from './types';

interface Props {
  form: any;
  info: SaleSubjectType;
  handleType: string;
  categoryArray: CategoryType[];
  selectedGroupId: string;
  clickDelete: Function;
}

function ModalClass(props: Props) {
  const { form, info, handleType, categoryArray, selectedGroupId, clickDelete } = props;
  const saleT: any = getLangList("sale");
  const buttonT: any = getLangList("button");

  useEffect(() => {
    const { saleSubjectName, saleGroupId } = info ?? {};

    handleType === 'update' && form.setFieldsValue({ saleSubjectName, saleGroupId });
    handleType === 'create' && form.setFieldsValue({ saleGroupId: Number(selectedGroupId) });
  }, [form, info, handleType, selectedGroupId]);

  return (
    <Form
      className="admin-form"
      style={{ marginTop: 20 }}
      {...modalFromLayout}
      form={form}
    >  
      <Form.Item
        label={saleT.CATEGORY}
        name="saleGroupId"
        rules={[{ required: true }]}
      >
        <Select
          showSearch
          style={{ width: "100%" }}
          optionFilterProp="children"
          filterOption={(input: any, option: any) => selectFilterOption(input, option)}
        >
          {getOptionArray(getDataArray(categoryArray, 'saleGroupId', 'saleGroupName'))}
        </Select>
      </Form.Item>

      <Form.Item
        label={saleT.SUBJECT}
        name="saleSubjectName"
        rules={[{ required: true }]}
      >
        <Input />
      </Form.Item>

      {handleType === 'update' && hasPermission('SALE_DELETE') &&
        <>
          <Divider dashed />
          <Form.Item label={buttonT.DELETE}>
            <ReButton onClick={clickDelete} attributeObject={{ type: "danger" }} iconName='delete' />
          </Form.Item>
        </>
      }
    </Form >
  );
}

export default ModalClass;